import { render, staticRenderFns } from "./AddDressAck.vue?vue&type=template&id=2091a86a&scoped=true"
import script from "./AddDressAck.vue?vue&type=script&lang=js"
export * from "./AddDressAck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2091a86a",
  null
  
)

export default component.exports